import React from "react";

const Select = ({ name, label, options, error, ...rest }) => {
  return (
    <div className="form-group">
      <div className="row">
        <label htmlFor={name} className="col-sm-3 col-form-label col-form-label-sm d-flex justify-content-sm-end align-items-sm-end pe-3 text-muted">{label}:</label>
        <div className="col-sm-8">
          <select name={name} id={name} {...rest} className="form-control form-control-sm" >
            <option value="" > -- Select {label} -- </option>
            {options.map(option => (
              <option key={option.id} data-tokens={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          {error && <div className="alert alert-danger small p-0">{error}</div>}
        </div>
      </div>
    </div>
    // <div className="form-group my-1">
    //   <label htmlFor={name} className="col-form-label col-form-label-sm">{label}</label>
    //   <select name={name} id={name} {...rest} className="form-control form-control-sm">
    //     <option value="" > {label+"?"} </option>
    //     {options.map(option => (
    //       <option key={option.id} value={option.value}>
    //         {option.label}
    //       </option>
    //     ))}
    //   </select>
    //   {error && <div className="alert alert-danger">{error}</div>}
    // </div>
  );
};

export default Select;
